import { render, staticRenderFns } from "./cardData.vue?vue&type=template&id=544fa6da&"
import script from "./cardData.vue?vue&type=script&lang=js&"
export * from "./cardData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cardData.vue"
export default component.exports